import { render, staticRenderFns } from "./CRing.vue?vue&type=template&id=54103739&scoped=true&"
import script from "./CRing.vue?vue&type=script&lang=js&"
export * from "./CRing.vue?vue&type=script&lang=js&"
import style0 from "./CRing.vue?vue&type=style&index=0&id=54103739&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54103739",
  null
  
)

export default component.exports